import * as React from "react";
import PropTypes from "prop-types";
import Backbone from "backbone";
import OccupanySetpointController from "./OccupanySetpointController";
import ThermostatSetpoints from "nx-components/Thermostat/ThermostatSetpoints";
import Platform from "nexia_mobile/platform";
import Dispatch from "nexia_mobile/flux_like/dispatch";
import connect from "nexia_mobile/flux_like/store/connect";
import DetailsSection from "nexia_mobile/components/Details/DetailsSection";
import UserLanguageContext from "nx-components/ContextWrappers/UserLanguageContext";

class ThermostatDetailControls extends React.Component {
  languageContext = this.context;
  language = this.languageContext.localeSet.nexia_mobile.controls
    .ThermostatDetailControls;
  static propTypes = {
    model: PropTypes.instanceOf(Backbone.Model).isRequired,
    isScreenReaderRunning: PropTypes.bool,
    showSpinner: PropTypes.func.isRequired, // (?string) => void
    hideSpinner: PropTypes.func.isRequired, // () => void
  };

  state = {
    pendingHeatValue: null,
    pendingCoolValue: null,
  };

  _isEditing = false;

  shouldComponentUpdate() {
    // If the user is currently changing their setpoint, don't
    // override the setpoint with a new value, because it's
    // annoying to change stuff while the user is changing it.
    // We miss an update, but since they're about to
    // set a new value, that's fine.
    return !this._isEditing;
  }

  handleChangesStarted = () => {
    this._isEditing = true;
    Dispatch("DISABLE_LOCATION_POLLING");
  };

  handleChangesEnded = ({ setpointHeat, setpointCool }) => {
    this._isEditing = false;
    Dispatch("ENABLE_LOCATION_POLLING");
    const { model, showSpinner, hideSpinner } = this.props;
    if (
      setpointHeat === model.get("setpoint_heat") &&
      setpointCool === model.get("setpoint_cool")
    ) {
      // They didn't change anything
      return;
    }

    let message;
    if (setpointHeat && setpointCool) {
      message = this.languageContext.template(
        this.language.heatAndCoolToTemplate,
        { setpointHeat, setpointCool }
      );
    } else if (setpointHeat) {
      message = this.languageContext.template(this.language.heatToTemplate, {
        setpointHeat,
      });
    } else if (setpointCool) {
      message = this.languageContext.template(this.language.coolToTemplate, {
        setpointCool,
      });
    }

    this.setState({
      pendingHeatValue: setpointHeat,
      pendingCoolValue: setpointCool,
    });
    showSpinner(message);
    const onDone = () => {
      this.setState({
        pendingHeatValue: null,
        pendingCoolValue: null,
      });
      hideSpinner();
    };
    model
      .setSetpoints({
        heat: setpointHeat,
        cool: setpointCool,
      })
      .then(onDone, onDone);
  };

  handleChangesCanceled = () => {
    this._isEditing = false;
    Dispatch("ENABLE_LOCATION_POLLING");
  };

  render() {
    const { model, isScreenReaderRunning } = this.props;
    const { pendingHeatValue, pendingCoolValue } = this.state;

    if (model.get("is_connected") === false) {
      return null;
    }

    let changeBufferMs;
    if (Platform.canDetectIfScreenReaderIsRunning() && isScreenReaderRunning) {
      changeBufferMs = 6000;
    }

    return (
      <OccupanySetpointController model={model}>
        {({
          setpointCoolMin,
          setpointCoolMax,
          setpointHeatMin,
          setpointHeatMax,
        }) => (
          <DetailsSection>
            <ThermostatSetpoints
              setpointCool={pendingCoolValue || model.get("setpoint_cool")}
              setpointCoolMin={setpointCoolMin}
              setpointCoolMax={setpointCoolMax}
              setpointDelta={model.get("setpoint_delta")}
              setpointHeat={pendingHeatValue || model.get("setpoint_heat")}
              setpointHeatMin={setpointHeatMin}
              setpointHeatMax={setpointHeatMax}
              setpointIncrement={model.get("setpoint_increment")}
              onChangesStarted={this.handleChangesStarted}
              onChangesEnded={this.handleChangesEnded}
              onChangesCanceled={this.handleChangesCanceled}
              changeBufferMs={changeBufferMs}
            />
          </DetailsSection>
        )}
      </OccupanySetpointController>
    );
  }
}

export default connect(
  {
    isScreenReaderRunning: "isScreenReaderRunning",
  },
  ThermostatDetailControls
);

ThermostatDetailControls.contextType = UserLanguageContext;



// WEBPACK FOOTER //
// ./src/components/Controls/Thermostat/ThermostatDetailControls.jsx